import { Injectable } from '@angular/core';

Injectable()
export class Globals {
    title = 'Dashboard';
    header = '';
}



// WEBPACK FOOTER //
// ./src/app/config/global.ts